import simg from '../images/service/1.jpg'
import simg2 from '../images/service/2.jpg'
import simg3 from '../images/service/3.jpg'
import simg4 from '../images/service/4.jpg'


import sIcon1 from '../images/icon/carpet.svg'
import sIcon2 from '../images/icon/season.svg'
import sIcon3 from '../images/icon/express-delivery.svg'
import sIcon4 from '../images/icon/cutlery.svg'



import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'



const Services = [
    {
        Id: '1',
        sImg: simg,
        sIcon: sIcon1,
        sTitle: 'Full-Service Association Management',
        description: `
    At Chrysalis Associates, our priority is delivering exceptional service while working side by side with each client. Our experienced community managers partner with boards to share best practices and strengthen every aspect of association management, including:
    
    * Board education and governance  
    * Vendor selection and cost-saving strategies  
    * Financial accounting, delinquency, and collections  
    * Site reviews, compliance, violations, and maintenance  
    * Homeowner engagement and sub-committee support  
    * Strategic planning and project oversight  
    
    What sets us apart is our unwavering commitment to client service combined with the industry’s most advanced technology. We’ve invested in innovative management software that streamlines operations, enhances transparency, and provides boards with powerful tools for effective decision-making.  
    
    Through strong partnerships and forward-thinking solutions, Chrysalis Associates offers a full spectrum of services to both residential and commercial associations. By blending personalized service with cutting-edge systems, we deliver top-tier results while keeping costs competitive, giving your community the attention it deserves and the efficiency it needs.
        `,
        ssImg1: sSingleimg1,
        ssImg2: sSingleimg2,
    },
    
    {
        Id: '2',
        sImg: simg2,          // update with your actual image variable
        sIcon: sIcon2,        // update with your actual icon variable
        sTitle: 'Financial Management Services',
        description: `
    At Chrysalis Associates, we ensure accurate and timely reporting across all areas of financial management, including:
    
    * Accounts payable  
    * Accounts receivable  
    * Bank reconciliations  
    * General ledger maintenance  
    * Financial statement preparation  
    * Budget planning  
    * Resale Disclosure preparation  
    * Participation in annual or budget meetings  
    
    **Financial Only Plus** – This customizable package can be tailored to meet your community’s specific needs by blending full-service and financial-only solutions. Additional services, such as management consulting, covenant enforcement support, and contract administration, can be added to the core financial-only package to fit your requirements.
        `,
        ssImg1: sSingleimg1,
        ssImg2: sSingleimg2,
    },
    
    {
        Id: '3',
        sImg: simg3,          // replace with your actual image var
        sIcon: sIcon3,        // replace with your actual icon var
        sTitle: 'On-Site Management Services',
        description: `
    At Chrysalis Associates, we offer exclusive access to a wide range of services designed to support the communities we manage. Whether you’re transitioning from another management provider or enhancing your budgeting process, we’re here to make things easier for you.  
    
    Some of the services we provide include:  
    
    * Strategic planning  
    * Financial management  
    * Physical asset analysis and preventive maintenance programs  
    * Leadership planning  
    * Proprietary technology innovations  
    * Board member training  
    * Transition programs  
    * Industry-leading training and professional development  
    * Workflow management systems and processes  
    * Value-added services such as combined buying power and negotiated vendor pricing  
    * 24/7 Customer Care Center  
    * Developer services  
    * Staff recruitment, training, and payroll services  
    
    No matter where your community is located, our mission is to make residents proud of where they live. We build lasting relationships by consistently delivering on our promises and exceeding expectations.
        `,
        ssImg1: sSingleimg1,
        ssImg2: sSingleimg2,
    },
    {
        Id: '4',
        sImg: simg4,          // replace with your actual image var
        sIcon: sIcon4,        // replace with your actual icon var
        sTitle: 'Property Management Services',
        description: `
    At Chrysalis Associates, we understand that nothing is more important than the condition and beauty of your community. Our managers are committed to maintaining the quality of your common areas and infrastructure. From routine grounds maintenance to managing the complex systems of high-rise buildings, we oversee the care of every aspect of your community.  
    
    We collaborate closely with your reserve specialist to ensure your reserve study covers all property components, and that repairs and new projects are properly included in each update. Our team carefully budgets for maintenance costs, reserve contributions, and anticipated expenditures, while maintaining detailed inventory, inspection, and maintenance schedules.  
    
    Your association is never limited to "preferred vendors." We conduct competitive and transparent bidding processes and work closely with service providers to deliver high-quality results.  
    
    Additionally, our managers develop emergency preparedness plans and remain available for emergency response **24/7**, ensuring peace of mind for your community at all times.
        `,
        ssImg1: sSingleimg1,
        ssImg2: sSingleimg2,
    },
    
]
export default Services;